module.exports = __webpack_public_path__ + "static/media/coursera-white.31e96d4c.svg";